import {useContext} from "react"
import {CategoryHelperContext} from "../../services/helpers/category-helper"
import React from "react"
import styles from "./category.module.scss"

interface CategoryProps {
  id: number
}

export const Category: React.FC<CategoryProps> = ({id}) => {
  const categoryHelper = useContext(CategoryHelperContext)
  if (categoryHelper === null) return null

  const category = categoryHelper.getCategoryName(id)
  const color = categoryHelper.mainColorById[id]
  return <span className={styles.Category} style={{backgroundColor: color}}>{category}</span>
}